export const maximumClientLogoFileSize = 5 * 1024 * 1024
export const maximumStoredClientLogoLength = 700_000
export const acceptedClientLogoTypes = ['image/png', 'image/jpeg', 'image/webp'] as const

export function clientLogoFileError(file: Pick<File, 'size' | 'type'>) {
  if (!acceptedClientLogoTypes.includes(file.type as typeof acceptedClientLogoTypes[number])) return 'Use uma imagem PNG, JPG ou WebP.'
  if (file.size > maximumClientLogoFileSize) return 'A imagem deve ter no máximo 5 MB.'
  return undefined
}

export function normalizeStoredClientLogo(value: unknown) {
  if (typeof value !== 'string' || value.length > maximumStoredClientLogoLength) return undefined
  return /^data:image\/(?:png|jpeg|webp);base64,[a-z0-9+/=]+$/i.test(value) ? value : undefined
}

function imageFromFile(file: File) {
  return new Promise<HTMLImageElement>((resolve, reject) => {
    const image = new Image()
    const objectUrl = URL.createObjectURL(file)
    image.onload = () => {
      URL.revokeObjectURL(objectUrl)
      resolve(image)
    }
    image.onerror = () => {
      URL.revokeObjectURL(objectUrl)
      reject(new Error('Não foi possível ler essa imagem.'))
    }
    image.src = objectUrl
  })
}

function renderLogo(image: HTMLImageElement, maximumDimension: number, quality: number) {
  const scale = Math.min(1, maximumDimension / image.naturalWidth, maximumDimension / image.naturalHeight)
  const canvas = document.createElement('canvas')
  canvas.width = Math.max(1, Math.round(image.naturalWidth * scale))
  canvas.height = Math.max(1, Math.round(image.naturalHeight * scale))
  const context = canvas.getContext('2d')
  if (!context) throw new Error('Não foi possível processar essa imagem.')
  context.imageSmoothingEnabled = true
  context.imageSmoothingQuality = 'high'
  context.drawImage(image, 0, 0, canvas.width, canvas.height)
  return canvas.toDataURL('image/webp', quality)
}

export async function optimizeClientLogo(file: File) {
  const validationError = clientLogoFileError(file)
  if (validationError) throw new Error(validationError)
  const image = await imageFromFile(file)
  if (!image.naturalWidth || !image.naturalHeight) throw new Error('A imagem selecionada está vazia ou corrompida.')
  let logo = renderLogo(image, 512, 0.88)
  if (logo.length > maximumStoredClientLogoLength) logo = renderLogo(image, 320, 0.74)
  if (logo.length > maximumStoredClientLogoLength) throw new Error('Não foi possível reduzir a imagem. Escolha um arquivo mais leve.')
  return logo
}
